// src/components/ForgotPasswordModal.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  FormLabel,
  OutlinedInput,
  Button,
  IconButton,
  Modal,
} from "@mui/material";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { ForgotPassword } from "../../Utility/UtilApi/UtilApi";
import {
  fontFamilyall,
  primaryColor,
  TextColor,
  ButtonsColor,
} from "../../UtilColorPalate/UtilColorPalate";

const ForgotPasswordModal = ({ isOpen, onClose, setToastmessage, setToastColor, handleSnackbarClick }) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    setEmail("");
  }, [isOpen]);

  const handleSubmit = () => {
    ForgotPassword({ email: email })
      .then((response) => {
        if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
          setToastColor(response?.data?.success);
          setToastmessage(response?.data?.message);
          handleSnackbarClick();
          onClose();
          setEmail("");
        }
      })
      .catch((err) => {
        console.log(err);
        setToastColor(err.response.data.success);
        setToastmessage(err.response.data.message);
        handleSnackbarClick();
      });
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          height: 250,
          bgcolor: "background.paper",
          borderRadius: "5px",
          p: 2,
          outline: "none",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          style={{
            fontFamily: fontFamilyall,
            textAlign: "center",
            fontSize: "20px",
            marginTop: "20px",
          }}
        >
          Forgot Password?
        </Typography>
     
        <div style={{ marginTop: "20px" }}>
          <FormControl sx={{ width: "100%" }}>
            <FormLabel
              htmlFor="email"
              style={{
                fontWeight: "bold",
                color: "#222",
                fontFamily: fontFamilyall,
              }}
            >
              User Name
            </FormLabel>
            <OutlinedInput
              sx={{
                height: "4ch",
                "& input": {
                  padding: "2px 0px 0px 10px",
                },
              }}
              name="email"
              id="email"
              type="email"
              value={email}
              fullWidth
              autoComplete="new-user"
              placeholder="User Name"
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            style={{
              fontFamily: fontFamilyall,
              color: TextColor,
              background: ButtonsColor,
            }}
            fullWidth
            onClick={handleSubmit}
          >
            Reset Password
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ForgotPasswordModal;